import React from 'react';
import { RootStateOrAny, useSelector } from 'react-redux';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { shouldEnableNewWeekView } from '../../../utils/newWeekViewFeatureFlags';
import OperationRestaurantCard from './OperationRestaurantCard';
import OperationRestaurantCardOld from './OperationRestaurantCardOld';

/**
 * Wrapper component that conditionally renders OperationRestaurantCard or OperationRestaurantCardOld
 * based on the newWeekView feature flag.
 */
const OperationRestaurantCardWrapper: React.FC = () => {
  const { newWeekViewFlags } = useFlags();
  const state = useSelector((state: RootStateOrAny) => state);

  const isNewWeekViewEnabled = shouldEnableNewWeekView(state, newWeekViewFlags);

  if (isNewWeekViewEnabled) {
    return <OperationRestaurantCard />;
  }

  return <OperationRestaurantCardOld />;
};

export { OperationRestaurantCardWrapper as OperationRestaurantCard };
export default OperationRestaurantCardWrapper;
